import { CommerceToolsApi } from '@grandvisionhq/commercetools'
import type { ProductDetail } from '@grandvisionhq/products'

type SpecificationConfiguration = React.ComponentPropsWithoutRef<
  typeof ProductDetail
>['specificationConfiguration']

export function getSpecifications(productType: string): SpecificationConfiguration | undefined {
  if (
    CommerceToolsApi.isSunglasses(productType) ||
    CommerceToolsApi.isFrames(productType) ||
    CommerceToolsApi.isReadyReaders(productType)
  ) {
    return [
      {
        labelKey: 'products.specifications.lensColor',
        attribute: 'lensColor',
        isLocalised: true,
      },
      {
        labelKey: 'products.specifications.frameColor',
        attribute: 'frameColor',
        isLocalised: true,
      },
      {
        labelKey: 'products.specifications.frameMaterial',
        attribute: 'frameMaterial',
        isLocalised: true,
      },
      {
        labelKey: 'products.specifications.frameShape',
        attribute: 'frameShape',
        isLocalised: true,
      },
      {
        labelKey: 'products.specifications.frameType',
        attribute: 'frameType',
        isLocalised: true,
      },
      {
        labelKey: 'products.specifications.gender',
        attribute: 'gender',
        isLocalised: true,
      },
    ]
  }

  if (CommerceToolsApi.isAccessories(productType)) {
    return [
      {
        labelKey: 'products.specifications.accessoryColor',
        attribute: 'accessoryColor',
        isLocalised: true,
      },
      {
        labelKey: 'products.specifications.material',
        attribute: 'material',
        isLocalised: true,
      },
      {
        labelKey: 'products.specifications.erpId',
        attribute: 'erpId',
        isLocalised: false,
      },
    ]
  }
}
